import React from 'react';
import './App.css';


import Input from './Components/Input'
import Display from './Components/Display'
import Header from './Components/Header'

import {TodoProvider} from './API'
function App() {

 

  return (
    <TodoProvider>
    <div className="App">
       <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                  <Header/>
                    <Input/>
                    <Display/>
                </div>
            </div>
        </div>
    </div>
    </TodoProvider>
  );
}

export default App;
